import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { NotificationService } from "../../services/Notification.service";
import { patch } from "../../services/useFetchAction";
import { requestEndpoint } from "../../data/requestEndpoint";
import { useStoreAuthV2 } from "../../store/AuthV2Store";
import { useStoreUserManager } from "../../store/UserManage";
import { useStorePageManager } from "../../store/PageManage";
import InputPhoneNumber from "../cells/InputPhoneNumber";

export const AuthV2SecondaryContactPanel = ({
  currentState = 1,
  panelState,
  setPanelState,
}) => {
  const { t } = useTranslation();
  const {
    socialLoginData,
    identifier,
    needsContact,
    needsSecondaryContact,
    setNeedsContact,
    setNeedsSecondaryContact,
  } = useStoreAuthV2();
  const handleUpdateUser = useStoreUserManager(
    (state) => state.handleUpdateUser
  );
  const handleUpdateConnexionPanelState = useStorePageManager(
    (state) => state.handleUpdateConnexionPanelState
  );

  const isContactMode = needsContact;

  const [loading, setLoading] = useState(false);
  const [phoneData, setPhoneData] = useState({
    telephone: "",
    indicatif: "",
  });
  const [stateTelephone, setStateTelephone] = useState({
    focus: false,
    error: false,
    good: false,
  });
  const [curentCountrySelected, setCurentCountrySelected] = useState();

  useEffect(() => {
    if (phoneData.telephone.length > 2) {
      if (phoneData.telephone.length >= 8) {
        setStateTelephone({ ...stateTelephone, error: false, good: true });
      } else {
        setStateTelephone({ ...stateTelephone, error: true, good: false });
      }
    } else {
      setStateTelephone({ ...stateTelephone, error: false, good: false });
    }
  }, [phoneData.telephone]);

  const handleUptadeTelephone = (e) => {
    let newTelephone = e.target.value.replace(/[^0-9]/g, "");
    setPhoneData({ ...phoneData, telephone: newTelephone });
    e.target.value = newTelephone;
  };

  const getPhoneNumber = () => {
    let tel = phoneData.indicatif + phoneData.telephone;
    if (tel[0] !== "+") tel = "+" + tel;
    return tel;
  };

  const isFormValid = () => {
    return stateTelephone.good && curentCountrySelected;
  };

  const handleValidate = async () => {
    if (!isFormValid() || loading) return;

    setLoading(true);
    try {
      const phoneNumber = getPhoneNumber();

      if (isContactMode) {
        await patch(requestEndpoint.updateProfilData, {
          contact: phoneNumber,
          indicatif: phoneData.indicatif.startsWith("+")
            ? phoneData.indicatif
            : "+" + phoneData.indicatif,
        });

        handleUpdateUser({ contact: phoneNumber });
        setNeedsContact(false);

        NotificationService.addToQueue(
          0,
          t("modals.connexionPanel.authV2.contactAdded")
        );
      } else {
        await patch(requestEndpoint.updateProfilData, {
          secondaryContact: phoneNumber,
        });

        setNeedsSecondaryContact(false);

        NotificationService.addToQueue(
          0,
          t("modals.connexionPanel.authV2.secondaryContactAdded")
        );
      }

      handleUpdateConnexionPanelState(false);
    } catch (error) {
      const errorMsg = error.response?.data?.message || error.message || "";

      if (errorMsg.includes("déjà") || errorMsg.includes("already")) {
        NotificationService.addToQueue(
          2,
          t("modals.connexionPanel.authV2.phoneAlreadyUsed")
        );
      } else if (errorMsg.includes("identique") || errorMsg.includes("same")) {
        NotificationService.addToQueue(
          2,
          t("modals.connexionPanel.authV2.secondaryContactSameAsPrimary")
        );
      } else {
        NotificationService.addToQueue(
          2,
          errorMsg || t("modals.connexionPanel.authV2.genericError")
        );
      }
    } finally {
      setLoading(false);
    }
  };

  const handleContactSupport = () => {
    window.open(
      "https://api.whatsapp.com/send?phone=+2250556094636&text=Bonjour%2C%20j%27ai%20besoin%20d%27aide%20pour%20mon%20inscription",
      "_blank"
    );
  };

  return (
    <div
      className={`contains inscription-part ${
        currentState === 0
          ? "go-left-side"
          : currentState === 1
            ? "come-center"
            : "go-right-side"
      } | flcolm`}
    >

      <span className="auth-v2-panel-title">
        {isContactMode
          ? t("modals.connexionPanel.authV2.contactTitle")
          : t("modals.connexionPanel.authV2.secondaryContactTitle")}
      </span>
      <label className="auth-v2-welcome">
        {isContactMode
          ? t("modals.connexionPanel.authV2.contactWelcome")
          : t("modals.connexionPanel.authV2.secondaryContactWelcome")}
      </label>
      <p className="auth-v2-subtitle">
        {isContactMode
          ? t("modals.connexionPanel.authV2.contactHint", {
              email: identifier || socialLoginData?.socialEmail,
            })
          : t("modals.connexionPanel.authV2.secondaryContactHint", {
              email: identifier || socialLoginData?.socialEmail,
            })}
      </p>

      <div className="input-field | flcolm">
        <InputPhoneNumber
          dataInscription={phoneData}
          setDataInscription={setPhoneData}
          setStateTelephone={setStateTelephone}
          stateTelephone={stateTelephone}
          handleUptadeTelephone={handleUptadeTelephone}
          curentCountrySelected={curentCountrySelected}
          setCurentCountrySelected={setCurentCountrySelected}
          setindicatif={(val) =>
            setPhoneData((prev) => ({ ...prev, indicatif: val }))
          }
          indicatif={phoneData.indicatif}
        />
      </div>

      <p className="auth-v2-info-text">
        {isContactMode
          ? t("modals.connexionPanel.authV2.contactInfo")
          : t("modals.connexionPanel.authV2.secondaryContactInfo")}
      </p>

      <div className="auth-v2-footer | flrow allcenter">
        <button
          onClick={handleContactSupport}
          className="btn-outline | btn flex"
        >
          {t("modals.connexionPanel.authV2.contactSupport")}
        </button>
        <button
          onClick={handleValidate}
          className="next-btn | btn flex"
          disabled={!isFormValid() || loading}
        >
          {loading
            ? t("modals.connexionPanel.authV2.loading")
            : t("modals.connexionPanel.authV2.validateBtn")}
        </button>
      </div>
    </div>
  );
};
